var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8 9.253c0 .72-.387 1.373-1 1.707l-2.32 1.253-1.974 1.054-4.093 2.213c-.44.24-.92.36-1.414.36-.493 0-.973-.12-1.413-.36l-8.387-4.52c-.613-.334-1-.987-1-1.707 0-.72.387-1.373 1-1.707l2.627-1.413L10.919 5l3.667-1.974c.88-.48 1.947-.48 2.827 0l8.386 4.52c.614.334 1 .987 1 1.707zM13.202 17.053l-7.8-3.907a1.902 1.902 0 0 0-1.866.08c-.574.347-.907.96-.907 1.627v7.374a3.33 3.33 0 0 0 1.853 3l7.8 3.893c.267.133.56.2.854.2a1.82 1.82 0 0 0 1-.293c.573-.347.906-.96.906-1.627v-7.373c.014-1.254-.693-2.4-1.84-2.974z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.376 14.867v7.373a3.325 3.325 0 0 1-1.853 2.987l-7.8 3.907a1.909 1.909 0 0 1-1.867-.094 1.914 1.914 0 0 1-.907-1.626v-7.36a3.33 3.33 0 0 1 1.854-3l2.866-1.427 2-1 2.934-1.467a1.87 1.87 0 0 1 1.866.08c.56.347.907.96.907 1.627z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBox);
export default __webpack_public_path__ + "static/media/ic-box.f143190fad98cdbd9ff3afd4808a251a.svg";
export { ForwardRef as ReactComponent };